<template>
  <Modal
    @close="$emit('close')"
    :classes="'col-md-4'"
    :title="'Cambiar Contraseña'"
  >
    <div slot="body" class="body">
      <div class="row">
        <div class="col">
          <CustomInput :icon="'fa fa-lock'">
            <input
              v-model="newPassword"
              type="text"
              slot="input"
              placeholder="Inserte nueva contraseña"
            />
          </CustomInput>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button class="button logo" @click="changePassword">
            Cambiar Contraseña
          </button>
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import { mapState } from "vuex";
import CustomInput from "@/components/CustomInput";
import Modal from "@/components/Modal";

export default {
  name: "ChangePasswordModal",
  components: {
    Modal,
    CustomInput,
  },
  computed: {
    ...mapState(["teacherData", "dataUrl"]),
  },
  data() {
    return {
      newPassword: null,
    };
  },
  methods: {
    async changePassword() {
      if (!this.newPassword) {
        this.$notify({
          title: ["Debe colocar nueva contraseña"],
          type: "danger",
        });
        return;
      }

      let apiUrl = `${this.dataUrl}/userProfile/updateUserPassword?userId=${this.teacherData.id}&password=${this.newPassword}`;
      let loader = this.$loading.show();

      try {
        let { data } = await this.axios.put(apiUrl);

        if (data.status.name.toLocaleLowerCase() == "ok") {
          this.$notify({
            title: ["Cambio exitoso"],
            type: "success",
          });
          this.$emit("close", this.newPassword);
        } else {
          this.$notify({
            title: ["Ocurrió un error", data.content],
            type: "danger",
          });
        }
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        loader.hide();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
